import React, { useContext } from "react";
import { ModalBody } from "reactstrap";
import ProductPage from "../product page/ProductPage";
import { AppContext } from "../../contexts/AppContext";
import { X } from "react-feather";
const QuickView = () => {
  const { toggleQuickViewModal } = useContext(AppContext);
  return (
    <>
      <span className="quick_view_x">
        <X className="cursor-pointer" onClick={toggleQuickViewModal} />
      </span>
      <ModalBody>
        <ProductPage />
      </ModalBody>
    </>
  );
};

export default QuickView;
